import React, { useEffect, useState } from 'react';
import { Outlet, useNavigate, useLocation } from 'react-router-dom';
import SecondaryNavBar from 'Components/SecondaryNavBar/SecondaryNavBar';

import "Container/Formulaires/FormulaireContainer/FormulaireContainer.scss";
import { useSelector } from "react-redux";

export default function FormulaireContainer () {

    const {
        detailPersonne,
        contrat,
    } = useSelector(state => ({
        ...state.gestionContratReducer,
    }))

    console.log("contrat")
    console.log(contrat)

    const produit = contrat?.produit

    const PRODUIT_MAINTIEN_SALAIRE = "MS"
    const PRODUIT_CAPITAL_DECES = "DC"

    // TODO PARAM PRODUIT REDUCE LIST
    const CONF = window?.confPub;
    const CONTAINER_PAGES = CONF?.ROUTES?.PAGES.FORMULAIRES?.CONTAINER;
    const ROUTE_LABEL = CONF?.LINK_LABEL?.ROUTES;

    const navigate = useNavigate();

    const location = useLocation();

    return (
        <div className="container mt-3">

            <SecondaryNavBar activePage='formulaires'/>

            <div className="formulaire-container">
                <h1>Formulaires</h1>

                <div className="row">
                    <div className="col-4">
                        <ul className='list-group'>

                            <li className={ `list-group-item  ${ location?.pathname === CONTAINER_PAGES?.CHANGEMENT_ADRESSE && "active" }` }>
                                <a className="" onClick={ () => navigate(CONTAINER_PAGES.CHANGEMENT_ADRESSE) }>
                                    { ROUTE_LABEL?.FORMULAIRES?.CHANGEMENT_ADRESSE }
                                </a>
                            </li>
                            <li className={ `list-group-item  ${ location?.pathname === CONTAINER_PAGES?.CHANGEMENT_COORDONNEES && "active" }` }>
                                <a className="" onClick={ () => navigate(CONTAINER_PAGES.CHANGEMENT_COORDONNEES) }>
                                    { ROUTE_LABEL?.FORMULAIRES?.CHANGEMENT_COORDONNEES }
                                </a>
                            </li>
                            <li className={ `list-group-item  ${ location?.pathname === CONTAINER_PAGES?.CHANGEMENT_NOM && "active" }` }>
                                <a className="" onClick={ () => navigate(CONTAINER_PAGES.CHANGEMENT_NOM) }>
                                    { ROUTE_LABEL?.FORMULAIRES?.CHANGEMENT_NOM }
                                </a>
                            </li>
                            <li className={ `list-group-item  ${ location?.pathname === CONTAINER_PAGES?.CHANGEMENT_NUM_SECURITE_SOCIALE && "active" }` }>
                                <a className=""
                                   onClick={ () => navigate(CONTAINER_PAGES.CHANGEMENT_NUM_SECURITE_SOCIALE) }>
                                    { ROUTE_LABEL?.FORMULAIRES?.CHANGEMENT_NIR }
                                </a>
                            </li>
                            { produit !== PRODUIT_MAINTIEN_SALAIRE && produit !== PRODUIT_CAPITAL_DECES && (
                                <li className={ `list-group-item  ${ location?.pathname === CONTAINER_PAGES?.CHANGEMENT_GARANTIE && "active" }` }>
                                    <a className="" onClick={ () => navigate(CONTAINER_PAGES.CHANGEMENT_GARANTIE) }>
                                        { ROUTE_LABEL?.FORMULAIRES?.CHANGEMENT_GARANTIE }
                                    </a>
                                </li>
                            )}
                            { produit !== PRODUIT_MAINTIEN_SALAIRE && produit !== PRODUIT_CAPITAL_DECES && (
                                <li className={ `list-group-item  ${ location?.pathname === CONTAINER_PAGES?.DEMANDE_DOCUMENT && "active" }` }>
                                    <a className="" onClick={ () => navigate(CONTAINER_PAGES.DEMANDE_DOCUMENT) }>
                                        { ROUTE_LABEL?.FORMULAIRES?.DOCUMENT }
                                    </a>
                                </li>
                            )}
                            { produit !== PRODUIT_CAPITAL_DECES && (
                                <li className={ `list-group-item  ${ location?.pathname === CONTAINER_PAGES?.CHANGEMENT_SITUATION && "active" }` }>
                                    <a className="" onClick={ () => navigate(CONTAINER_PAGES.CHANGEMENT_SITUATION) }>
                                        { ROUTE_LABEL?.FORMULAIRES?.CHANGEMENT_SITUATION }
                                    </a>
                                </li>
                            )}
                            { produit !== PRODUIT_MAINTIEN_SALAIRE && produit !== PRODUIT_CAPITAL_DECES && (
                                <li className={ `list-group-item  ${ location?.pathname === CONTAINER_PAGES?.AJOUT_AYANT_DROITS && "active" }` }>
                                    <a className="" onClick={ () => navigate(CONTAINER_PAGES.AJOUT_AYANT_DROITS) }>
                                        { ROUTE_LABEL?.FORMULAIRES?.AJOUT_AYANT_DROIT }
                                    </a>
                                </li>
                            )}
                            { produit !== PRODUIT_MAINTIEN_SALAIRE && produit !== PRODUIT_CAPITAL_DECES && (
                                <li className={ `list-group-item  ${ location?.pathname === CONTAINER_PAGES?.RADIATION_AYANT_DROIT && "active" }` }>
                                    <a className="" onClick={ () => navigate(CONTAINER_PAGES.RADIATION_AYANT_DROIT) }>
                                        { ROUTE_LABEL?.FORMULAIRES?.RADIATION_AYANT_DROIT }
                                    </a>
                                </li>
                            )}
                            <li className={ `list-group-item  ${ location?.pathname === CONTAINER_PAGES?.DECLARAION_DECES && "active" }` }>
                                <a className="" onClick={ () => navigate(CONTAINER_PAGES.DECLARAION_DECES) }>
                                    { ROUTE_LABEL?.FORMULAIRES?.DECLARAION_DECES }
                                </a>
                            </li>
                            <li className={ `list-group-item  ${ location?.pathname === CONTAINER_PAGES?.CHANGEMENT_RIB && "active" }` }>
                                <a className="" onClick={ () => navigate(CONTAINER_PAGES.CHANGEMENT_RIB) }>
                                    { ROUTE_LABEL?.FORMULAIRES?.CHANGEMENT_RIB }
                                </a>
                            </li>
                        </ul>
                    </div>

                    <div className="col-8">

                        <div className='container'>
                            <div className="card">
                                <div className="card-header">
                                    <h2>Membre Participant</h2>
                                </div>
                                <div className="card-body">

                                    <dl className="row">
                                    <dt className="col-sm-3">
                                            Numéro MNH :
                                        </dt>
                                        <dd className="col-sm-8">
                                            { detailPersonne?.contrat?.[0]?.numeroContrat }
                                        </dd>

                                        <dt className="col-sm-3">
                                            Nom :
                                        </dt>
                                        <dd className="col-sm-8">
                                            { detailPersonne?.nom }
                                        </dd>

                                        <dt className="col-sm-3">
                                            Prénom :
                                        </dt>
                                        <dd className="col-sm-8">
                                            { detailPersonne?.prenom }
                                        </dd>
                                    </dl>

                                </div>
                            </div>
                        </div>

                        <Outlet />
                    </div>
                </div>
            </div>
        </div>
    )
}